import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'back-drop',
  props: {
    hiddenBackdrop: { type: Boolean },
    value: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})